/**
 * BatchRemoveCargaResponse
 * @author ftgibran
 */
import {$, Helper, Model, Request} from 'simpli-web-sdk'

export class BatchRemoveCargaResponse extends Model {
  successQty: number | null = null
  ignoredQty: number | null = null
}
